import React from "react";
import { Helmet } from "react-helmet";

export default function PageMetaTags({
  meta_title,
  meta_keyword,
  meta_description,
}) {
  return (
    <>
      <Helmet>
        <title>{meta_title}</title>
        {/* <meta name="robots" content="noindex, nofollow" /> */}
        <meta name="keywords" content={meta_keyword} />
        <meta name="description" content={meta_description} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
    </>
  );
}
